export const API_URL = process.env.REACT_APP_API_URL;
// export const API_URL = 'https://core.webholding-staging.ii.staging-00.bestdoctor.dev/api';

export const HEADER_ACCEPT_HR = 'application/vnd.bestdoctor.v1-hr';

